<template>
  <div class="learning-path-videos">
    <LineHeading background="white" class="mb-3">Suggested Videos</LineHeading>
    <div class="video-list row no-gutters">
      <div
        v-for="(video, i) in learningPath.suggested_videos"
        :key="i"
        class="col-12 mb-3 col-md-6 col-lg-4 mb-lg-4"
        :class="{
          'pr-md-1': i % 2 === 0,
          'pl-md-1': i % 2 === 1,
          'pr-lg-1 pl-lg-0': i % 3 === 0,
          'px-lg-1': i % 3 === 1,
          'pl-lg-1 pr-lg-0': i % 3 === 2,
        }"
      >
        <div class="video-card p-0" @click="show(video)">
          <div class="video-card-landscape d-lg-none">
            <div class="video-image-wrap">
              <div
                class="video-image"
                :style="`background-image:url('${video.image_url}');`"
              >
                <span class="video-length">{{ video.length }}</span>
              </div>
            </div>
            <div class="video-details-wrap pl-3">
              <div class="video-title mb-1">{{ video.title }}</div>
              <div class="video-meta">
                <span>{{ video.publish_on | moment("M/D/YYYY") }}</span>
              </div>
            </div>
          </div>
          <div class="video-card-portrait d-none d-lg-block">
            <div class="video-image-wrap">
              <div
                class="video-image"
                :style="`background-image:url('${video.image_url}');`"
              >
                <span class="video-length">{{ video.length }}</span>
              </div>
            </div>
            <div class="video-details-wrap pt-3">
              <div class="video-title mb-1">{{ video.title }}</div>
              <div class="video-meta">
                <span>{{ video.publish_on | moment("M/D/YYYY") }}</span>
              </div>
            </div>
          </div>
        </div>
        <hr class="d-md-none" />
      </div>
    </div>
  </div>
</template>

<script>
import VideoModal from "components/pages/videos/partials/VideoModal";
export default {
  props: {
    learningPath: { type: Object, required: true },
  },
  methods: {
    show(video) {
      if (window.innerWidth < 768) {
        this.goToRoute("videos.show", { video: video.id });
      } else {
        this.$modal(VideoModal, { video: video })
          .then(() => {})
          .catch(() => {});
      }
    },
  },
};
</script>
